import {
  connect,
  FormikActions,
  FormikConsumer,
  FormikContext,
  FormikState,
} from 'formik'
import React from 'react'

type EffectState<TValues> = Pick<
  FormikState<TValues>,
  'values' | 'touched' | 'errors' | 'isSubmitting'
>
export interface EffectProps<TValues> {
  onChange: (
    state: EffectState<TValues>,
    nextState: EffectState<TValues>,
    actions: FormikActions<TValues>
  ) => void
  formik: FormikContext<TValues>
}

class Effect<TValues> extends React.Component<EffectProps<TValues>> {
  public componentWillReceiveProps(nextProps: EffectProps<TValues>) {
    const { values, touched, errors, isSubmitting } = this.props.formik
    const {
      values: nextValues,
      touched: nextTouched,
      errors: nextErrors,
      isSubmitting: nextIsSubmitting,
    } = nextProps.formik
    if (nextProps.formik !== this.props.formik) {
      this.props.onChange(
        {
          values,
          touched,
          errors,
          isSubmitting,
        },
        {
          values: nextValues,
          touched: nextTouched,
          errors: nextErrors,
          isSubmitting: nextIsSubmitting,
        },
        nextProps.formik
      )
    }
  }

  // eslint-disable-next-line
  public render() {
    return null
  }
}

export const FormikEffectFactory =
  <TValues extends any>(
    onChange: (
      state: EffectState<TValues>,
      nextState: EffectState<TValues>,
      actions: FormikActions<TValues>
    ) => void
  ): React.FunctionComponent =>
  () =>
    (
      <FormikConsumer>
        {(formik) => <Effect onChange={onChange} formik={formik} />}
      </FormikConsumer>
    )

export const FormikEffect = connect<Omit<EffectProps<any>, 'formik'>>(Effect)

export default FormikEffect
